<template>
  <div class="banner membership mb-3">
    <div class="text-wrapper">
      <div class="text-wrap">
        <div>
          <h4>{{ membershipType.name }}</h4>
          <membership-price :membership-type="membershipType" :show-trial="showTrial"/>
          <MembershipTypeDescription :membership-type="membershipType"/>
        </div>
<!--        <div>
          <h4>
            {{ $t('membership.priceInfo') }} {{ $n(membershipType.price, `${branch}_currency`) }}
          </h4>
        </div>-->
        <div class="membership-actions">
          <outline-button v-if="isPublic && learnMoreUrl" @click.prevent="learnMore" class="mr-3">{{ $t('membership.learnMore')}}</outline-button>
          <primary-button @click.prevent="onClick" :enabled="buttonEnabled" cta>{{buttonLabel}}</primary-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PrimaryButton from "@/components/buttons/PrimaryButton";
import slugify from "slugify";
import markdown from "markdown";
import {i18n} from "../../lang/setup";
import OutlineButton from "../buttons/OutlineButton";
import MembershipPrice from "./MembershipPrice";
import MembershipTypeDescription from "./MembershipTypeDescription.vue";

export default {
  name: 'MembershipType',
  components: { MembershipPrice, OutlineButton, PrimaryButton, MembershipTypeDescription },
  props: {
    membershipType: {},
    buttonLabel: {
      type: String,
    },
    buttonEnabled: {
      type: Boolean,
      default: true,
    },
    showTrial: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isPublic() {
      return this.membershipType.visibility == 'public'
    },
    learnMoreUrl() {
      if (!process.env.FG_MEMBERS_INFO_URL) {
        return null;
      }
      return process.env.FG_MEMBERS_INFO_URL + `#${slugify(this.membershipType.name, {strict: true})}`;
    },
  },
  methods: {
    onClick() {
      this.$emit('open-checkout', this.membershipType)
    },
    learnMore() {
      window.open(this.learnMoreUrl)
    }
  }
}
</script>
<style lang="scss" scoped>
.banner {
  position: relative;
  //height: 180px;
  //overflow: hidden;
  .invite-only {
    font-family: $secondary-font-family;
    font-size: 1rem;
    color: #1F2429;
  }
  .membership-actions {
    margin-top: 24px;
  }
  .text-wrapper {
    //position: absolute;
    //left: 0;
    //top: 0;
    //color: $white;
    //height: 100%;
    //width: 100%;

    .text-wrap {
      //padding: 30px 30px 0;
      //display: flex;
      //flex-direction: column;
      //height: 100%;
      //width: 70%;
      //div {
      //  flex:1;
      //  &:first-child {
      //    flex:0;
      //  }
      //  &:nth-child(2) {
      //    @media screen and (max-width: 750px) {
      //      flex: 0 1 0;
      //    }
      //  }
      //  &:last-child {
      //    margin-bottom: 60px;
      //    flex: 0 1 0;
      //    @media screen and (max-width: 750px) {
      //      margin-bottom: 20px;
      //    }
      //  }
      //}

      font-size: 1rem;

      h2 {
        // font-size: 1.5rem;
        margin-bottom: 20px;
      }
      h4 {
        //font-size: 1rem;
        //font-family: $secondary-font-family
        margin-bottom: 20px;
      }
      a {
        // font-size: 1.5rem;
      }
    }
  }

  @media screen and (max-width: 768px) {
    //img {
    //  width: 100%;
    //}
  }

  @media screen and (max-width: 750px) {
    height: auto;
    .text-wrapper {
      position: static;
      margin-top: 30px;
      .text-wrap {
        display: block;
        width: 100%;
        padding: 0;
        & > div {
          &:last-child {
            margin-bottom: 0;
            margin-top: 0;
          }
        }
      }
    }
  }
}

.banner {
  height: 100%;
  //background-color: #20252A;
  max-width: 746px;
  //background-image: url("https://fotografiska.com/app/themes/fotografiska_ny/assets/images/test-image.png");
  background-repeat: no-repeat;
  @media screen and (max-width: 750px) {
    //background-image: url("//www.fotografiska.com/app/themes/fotografiska_ny/assets/images/test-image-mob.png");
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>
